export const services = [
  {
    id: 1,
    title: "Automações",
    description: "Automatize processos repetitivos e ganhe tempo para focar no que realmente importa. Criamos fluxos inteligentes que trabalham 24/7 por você.",
    icon: "Zap",
    features: ["Chatbots inteligentes", "E-mail marketing automatizado", "Integração de sistemas", "Fluxos de vendas"]
  },
  {
    id: 2,
    title: "Gestão de Redes Sociais",
    description: "Conteúdo estratégico que conecta sua marca ao público certo. Criamos, publicamos e gerenciamos suas redes com resultados reais.",
    icon: "Share2",
    features: ["Criação de conteúdo", "Planejamento editorial", "Análise de métricas", "Engajamento orgânico"]
  },
  {
    id: 3,
    title: "Tráfego Pago",
    description: "Investimento inteligente em anúncios que geram resultados. Google Ads, Meta Ads e muito mais para escalar seu negócio.",
    icon: "TrendingUp",
    features: ["Google Ads", "Meta Ads", "TikTok Ads", "Remarketing avançado"]
  },
  {
    id: 4,
    title: "Desenvolvimento de Sites",
    description: "Sites modernos, rápidos e otimizados para conversão. Do design ao código, criamos experiências digitais que impressionam.",
    icon: "Code",
    features: ["Landing pages", "Sites institucionais", "SEO otimizado"]
  }
];

export const stats = [
  { id: 1, value: 30, suffix: "+", label: "Clientes atendidos" },
  { id: 2, value: 50, suffix: "+", label: "Projetos entregues" },
  { id: 3, value: 98, suffix: "%", label: "De satisfação" }
];

export const portfolioItems = [
  
  {
    id: 2,
    title: "Automação focada em conversão",
    category: "Automações",
    result: "+50% em conversões",
    image: "/auto.png"
  },
  {
    id: 3,
    title: "Rebranding Redes Sociais",
    category: "Redes Sociais",
    result: "+62% de engajamento",
    image: "/brand.png"
  },
  {
    id: 4,
    title: "Site Institucional Premium",
    category: "Desenvolvimento",
    result: "+50% de leads",
    image: "/sites.png"
  },
  {
    id: 5,
    title: "Posicionamento Digital Completo",
    category: "Tráfego Pago",
    result: "R$30k gerados",
    image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop"
  },
  {
    id: 6,
    title: "Gestão Completa de Social",
    category: "Redes Sociais",
    result: "+10k seguidores",
    image: "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=600&h=400&fit=crop"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Lucas Mendes",
    role: "CEO, TechStart",
    text: "A Movii transformou completamente nossa presença digital. Em 3 meses triplicamos nossas vendas online. A equipe é extremamente profissional e criativa.",
    avatar: "LM"
  },
  {
    id: 2,
    name: "Ana Carolina",
    role: "Diretora, Bella Fashion",
    text: "O trabalho de gestão de redes sociais é impecável. Nosso engajamento cresceu exponencialmente e a qualidade do conteúdo é de outro nível.",
    avatar: "AC"
  },
  {
    id: 3,
    name: "Rafael Torres",
    role: "Fundador, FitLife",
    text: "As automações implementadas pela Movii economizaram horas do nosso dia. O chatbot sozinho aumentou nossa conversão em 200%.",
    avatar: "RT"
  },
  {
    id: 4,
    name: "Mariana Silva",
    role: "Gerente, Nova Imobiliária",
    text: "O site que desenvolveram para nós é simplesmente incrível. Moderno, rápido e nossos clientes adoram a experiência de navegação.",
    avatar: "MS"
  },
  {
    id: 5,
    name: "Pedro Oliveira",
    role: "CMO, DataDrive",
    text: "ROI absurdo com tráfego pago! A equipe da Movii realmente entende de performance. Melhor investimento que fizemos em marketing.",
    avatar: "PO"
  }
];

export const navLinks = [
  { label: "Início", href: "#hero" },
  { label: "Serviços", href: "#servicos" },
  { label: "Resultados", href: "#resultados" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "Contato", href: "#contato" }
];

export const footerLinks = {
  servicos: [
    { label: "Automações", href: "#servicos" },
    { label: "Gestão de Redes Sociais", href: "#servicos" },
    { label: "Tráfego Pago", href: "#servicos" },
    { label: "Desenvolvimento de Sites", href: "#servicos" }
  ],
  empresa: [
    { label: "Sobre nós", href: "#" },
    { label: "Nosso time", href: "#" },
    { label: "Blog", href: "#" },
    { label: "Carreiras", href: "#" }
  ],
  contato: {
    email: "movii.agencia.br@gmail.com",
    phone: "(71) 92004-6893",
    address: "Salvador, BA - Brasil"
  },
  social: [
    { label: "Instagram", href: "https://www.instagram.com/movii.agencia/", icon: "Instagram" },
    { label: "YouTube", href: "https://youtube.com/@MoviiAgência", icon: "Youtube" }
  ]
};

export const logos = {
  white: "https://customer-assets.emergentagent.com/job_f5193f2e-8211-4a60-824b-63b05f3a23ef/artifacts/ujo9pjyq_ChatGPT%20Image%2012%20de%20fev.%20de%202026%2C%2014_40_46.png",
  blue: "https://customer-assets.emergentagent.com/job_f5193f2e-8211-4a60-824b-63b05f3a23ef/artifacts/obdfmr9d_movii%20azul.png",
  blueLight: "https://customer-assets.emergentagent.com/job_movii-flow/artifacts/6zd06b5u_ChatGPT%20Image%2012%20de%20fev.%20de%202026%2C%2016_17_23.png"
};
